
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11788',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11788",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.291",
  "data-fetching-client": "static-1.9549",
  "foundations-components": "static-1.7656",
  "foundations-components-legacy": "static-1.681",
  "foundations-theming": "static-1.4283",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.79",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7883",
  "hub-http-shared-msw-handlers": "static-1.9648",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11315",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6342",
  "marketplace-storefront-base": "static-1.11849",
  "quartz": "static-1.6828",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16524",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2735",
  "reporting-testing-lib": "static-1.8764",
  "settings-ui-lib": "static-1.12395",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6876",
  "ui-addon-i18n": "static-1.11018",
  "ui-addon-react-router-dom": "static-1.9417",
  "unified-auth": "static-1.308",
  "unified-auth-core-lib": "static-1.589",
  "usage-tracker": "static-1.7209",
  "usage-tracker-core": "static-1.7059",
  "customer-data-property-utils": "static-1.7954",
  "history": "static-4.47",
  "hub-http": "static-1.6091",
  "integrations-lib": "static-1.15645",
  "marketplace-ui-common": "static-1.19164",
  "property-management-iframe": "static-1.12656",
  "quartz-config": "static-1.606",
  "quartz-core": "static-1.6047",
  "quartz-routing": "static-1.258",
  "quick-fetch": "static-1.3807",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4516",
  "ts-schema": "static-1.3974",
  "ui-universal-auth": "static-1.8794",
  "UIComponents": "static-3.8262",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3298",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3105",
  "quartz-webpack": "static-1.3052",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3925",
  "floating-ui": "static-1.53",
  "foundations-assets": "static-1.4712",
  "foundations-theming-specialty": "static-1.1999",
  "framer-motion": "static-1.69",
  "hs-story-utils": "static-1.9299",
  "react-aria": "static-1.63",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5242",
  "react-virtualized": "static-2.96",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1419",
  "ui-fonts": "static-1.577",
  "ui-images": "static-2.1123",
  "bend-plugin-foundations-theming": "static-1.2766",
  "foundations-theming-base": "static-1.3268",
  "stylex": "static-1.29",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.2994",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4198",
  "ai-components-ui-library": "static-1.8565",
  "ai-rendering-library": "static-1.9554",
  "chirp-fetch": "static-1.1755",
  "connections-embed-lib": "static-1.736",
  "copilot-toolkit": "static-1.10730",
  "laboratory-lib": "static-3.7033",
  "marketplace-embed": "static-1.21663",
  "marketplace-ui-details": "static-1.9060",
  "marketplace-ui-reviews": "static-1.19120",
  "marketplace-ui-tracking": "static-1.13335",
  "sanitize-text": "static-1.8017",
  "ui-addon-video-player": "static-1.8568",
  "usage-tracker-multi": "static-1.5623",
  "usage-tracker-session-replay": "static-1.4895",
  "wootric-nps": "static-1.6856",
  "apollo-link-hub-http": "static-2.4523",
  "immer": "static-1.33",
  "immerable": "static-1.4026",
  "highcharts": "static-8.101",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2414",
  "reporting-data": "static-1.66831",
  "cssUtils": "static-1.764",
  "flux-actions": "static-1.323",
  "HubStyle": "static-2.11623",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10083",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10246",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7199",
  "icons": "static-2.637",
  "marketplace-ui-apps-core": "static-1.17697",
  "storybook-react": "static-1.30",
  "trellis-story-utils": "static-1.4392",
  "foundations-components-test-utils": "static-1.5139",
  "quartz-i18n": "static-1.503",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3603",
  "customer-data-objects": "static-1.7526",
  "property-translator": "static-1.5280",
  "frontend-preferences-client": "static-1.7796",
  "hs-promise-utils": "static-1.5468",
  "hubspot-apollo-client": "static-1.4751",
  "integrations-error-boundary-lib": "static-1.13060",
  "integrations-tracking-lib": "static-1.5464",
  "native-integrations-shared-strings": "static-1.7659",
  "reselect": "static-2.16",
  "sanitize": "static-1.4346",
  "superstore": "static-1.4641",
  "ui-shepherd-react": "static-3.10018",
  "ai-settings-ui-library": "static-1.7665",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4547",
  "immutable-less": "static-1.4526",
  "marketplace-ui-client-types": "static-1.16571",
  "nav-meta": "static-1.29155",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10114",
  "ui-addon-upgrades": "static-9.17771",
  "inbound-db-properties-service-client": "static-1.3740",
  "property-management-common": "static-1.4944",
  "ui-addon-iframeable": "static-1.8919",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.503",
  "quartz-head": "static-1.493",
  "quartz-test": "static-1.503",
  "quartz-tracking": "static-1.207",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3025",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20642",
  "ContentUtils": "static-1.67844",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2366",
  "customer-data-filters-ui": "static-1.39166",
  "customer-data-objects-ui-components": "static-1.12885",
  "customer-data-reference-ui-components": "static-1.13021",
  "embedded-academy-lib": "static-1.13817",
  "ExportDialog": "static-6.10261",
  "highlight.js": "static-1.76",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40850",
  "reporting-snowflake": "static-1.55449",
  "reporting-ui-components": "static-2.64102",
  "reporting-visualizations": "static-1.58907",
  "ui-addon-teams": "static-1.21347",
  "magpie-lib": "static-1.5466",
  "magpie-types": "static-1.4926",
  "simple-logging-lib": "static-1.2922",
  "navigation-components": "static-1.17518",
  "ai-studio-lib": "static-1.11196",
  "app-governance-lib": "static-1.1102",
  "developer-experience-shared-components": "static-1.10374",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7863",
  "ui-product-approvals": "static-1.27699",
  "ui-tool-access": "static-1.10017",
  "usage-based-billing-components-lib": "static-1.8213",
  "usage-tracker-anonymous": "static-1.5626",
  "usage-tracker-public": "static-1.7020",
  "amplitude-session-replay-browser": "static-1.57",
  "inbound-db-meta-service-client": "static-1.3484",
  "persist-promise": "static-1.3581",
  "reference-resolvers": "static-1.8037",
  "ui-extensibility-client-types": "static-1.3814",
  "hubspot-apollo-cache": "static-1.210",
  "universal-page-editor-lib": "static-1.2874",
  "final-form": "static-1.67",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2379",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4942",
  "purchase-motions-components": "static-1.5608",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1424",
  "crm-component-utils": "static-1.38665",
  "crm-properties-common-lib": "static-1.5745",
  "customer-data-properties": "static-1.51019",
  "framework-data-schema-resolvers": "static-1.6747",
  "property-value-citations": "static-1.1633",
  "reference-resolvers-lite": "static-1.7958",
  "navigation-messaging": "static-1.6845",
  "hubspotter-http-shared-msw-handlers": "static-1.9646",
  "cms-field-types": "static-1.4681",
  "content-icons-ui": "static-1.2187",
  "conversations-skeleton-state": "static-1.7121",
  "crm-message-bus": "static-1.42584",
  "customer-data-filters-ui-msw-helpers": "static-1.21601",
  "customer-data-ui-utilities": "static-1.9696",
  "FormUrlGenerator": "static-2.4593",
  "framework-builder-read-service-client": "static-1.3902",
  "framework-data-schema-quick-fetch": "static-1.6652",
  "multi-account-reference-resolvers": "static-1.850",
  "onboarding-tours": "static-1.16368",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13265",
  "academy-common-lib": "static-1.13277",
  "content-assistance-lib": "static-1.7549",
  "dashboard-lib": "static-1.80926",
  "file-manager-components": "static-1.23142",
  "getting-started-shared-tasks": "static-1.18082",
  "hubspot-prosemirror": "static-1.17815",
  "hubspot-prosemirror-plugins": "static-1.17807",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19598",
  "share-with-third-party-component-lib": "static-1.8565",
  "ui-addon-draggable": "static-3.4640",
  "ui-asset-management-lib": "static-1.10815",
  "ui-business-units-lib": "static-1.8905",
  "user-context": "static-1.4972",
  "growth-payments-core": "static-1.24930",
  "reporting-plugins": "static-1.10070",
  "reporting-reports": "static-1.66509",
  "idb-keyval": "static-1.41",
  "reactive-lib": "static-1.597",
  "codemirror": "static-5.92",
  "feedback-loader": "static-1.29018",
  "react-codemirror": "static-1.10498",
  "framework-listing-lib": "static-2.28242",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30307",
  "apps-service-types": "static-1.3749",
  "oauth-service-types": "static-1.4119",
  "onboarding-scopes": "static-1.6335",
  "onboarding-tours-client": "static-1.4582",
  "platform-infra-nav-components": "static-1.7561",
  "subscription-experience-data-types": "static-1.14680",
  "crm-record-cards-service-types": "static-1.3511",
  "location-customization-utils-lib": "static-1.8786",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4371",
  "nav-client-types": "static-1.2229",
  "purchase-motions-api": "static-1.5611",
  "signup-constants": "static-1.18559",
  "signup-ui-url-generator": "static-2.7907",
  "trials-service-types": "static-1.3772",
  "card-properties-lib": "static-1.43729",
  "commerce-subscription-lib": "static-1.36665",
  "crm-actions": "static-1.6183",
  "crm-cards-sdk": "static-1.43141",
  "customer-data-properties-shared-msw-handlers": "static-1.8975",
  "customer-data-tracking": "static-1.6756",
  "hs-entities": "static-1.561",
  "pulse": "static-1.400",
  "calling-global-api": "static-1.63952",
  "calling-internal-common": "static-1.31172",
  "calling-lifecycle-internal": "static-1.65334",
  "calling-lifecycle-messages": "static-1.57628",
  "commerce-products-lib": "static-1.9046",
  "conditional-properties-service-client": "static-1.3692",
  "crm-links": "static-1.6143",
  "external-options-client-types": "static-1.4053",
  "google-libphonenumber": "static-1.35",
  "inbounddb-objects-service-types": "static-1.4117",
  "meetings-icalendar-utils-lib": "static-1.504",
  "multi-currency-client-types": "static-1.3584",
  "object-builder-ui-client": "static-1.48249",
  "pipeline-validation-client-types": "static-1.3858",
  "smart-property-lib": "static-1.6232",
  "tiered-pricing": "static-1.945",
  "ui-addon-form-validation": "static-1.10865",
  "crm-pipelines-api-client-types": "static-1.4036",
  "react-dnd-compat": "static-1.4492",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5232",
  "growth-onboarding-confetti": "static-1.2944",
  "growth-onboarding-next-action-utils": "static-1.1488",
  "onboarding-tours-utils": "static-1.434",
  "ui-shepherd-tracker": "static-1.7399",
  "academy-service-client": "static-1.3552",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28136",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8257",
  "video-components-external": "static-1.10805",
  "video-data-lib": "static-1.34463",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8430",
  "payment-link-components": "static-1.23128",
  "ui-addon-emoji-picker": "static-1.9759",
  "EmailSignatureEditor": "static-1.24048",
  "viral-links-lib": "static-1.6912",
  "data-token-picker": "static-1.16169",
  "FileManagerLib": "static-1.38782",
  "react-flip-move": "static-1.67",
  "timezone-utils": "static-2.5116",
  "getting-started-shared-tasks-store": "static-1.17200",
  "campaign-roi-lib": "static-1.8499",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7194",
  "customer-data-views-management": "static-1.25136",
  "framework-data-table": "static-2.11595",
  "marketing-platform-lib": "static-1.6719",
  "nudge-client-utils": "static-1.2296",
  "nudge-custom-ui-functions": "static-1.797",
  "app-users-service-client": "static-1.5417",
  "app-users-service-types": "static-1.4825",
  "mini-checkout-client": "static-1.26491",
  "onboarding-utils": "static-1.5224",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28121",
  "edison-service-client-types": "static-1.264",
  "eligibility-engine-service-types": "static-1.3053",
  "crm_data": "static-4.91488",
  "customer-data-sidebar": "static-2.45613",
  "enrichment-properties-lib": "static-1.15350",
  "commerce-billing-lib": "static-1.18688",
  "commerce-shared-components-lib": "static-1.18149",
  "commerce-tools-ui-lib": "static-1.9987",
  "crm-fe-perf": "static-1.22776",
  "directed-graph": "static-1.811",
  "event-emitter": "static-1.819",
  "fast-json-patch": "static-1.60",
  "calling-error-reporting": "static-1.31178",
  "shared-worker-versioning": "static-1.10911",
  "calling-usage-tracker": "static-1.6413",
  "voice-sms-access-library": "static-1.457",
  "commerce-permissions": "static-1.637",
  "products-iframe-lib": "static-1.7532",
  "products-ui-components-shared-msw-handlers": "static-1.10030",
  "breeze-intelligence-kit": "static-1.5422",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9731",
  "policy-lib": "static-1.6651",
  "react-tinymce": "static-1.54827",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9794",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53953",
  "tinymce-plugins": "static-1.57067",
  "tinymce-themes": "static-1.55923",
  "growth-onboarding-next-action-components": "static-1.1516",
  "user-context-client": "static-1.4485",
  "growth-onboarding-feedback-components": "static-1.6453",
  "content-media-composition-data-lib": "static-1.11744",
  "content-media-compositions": "static-2.15751",
  "media-bridge-lib": "static-1.18691",
  "commerce-tours-lib": "static-1.5837",
  "growth-onboarding-reliability": "static-1.4958",
  "sales-checkout-service-client": "static-1.3540",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21436",
  "sales-email-signature-service-client": "static-1.3715",
  "audio-components": "static-1.5713",
  "FileManagerCore": "static-1.38641",
  "FileManagerImages": "static-1.36293",
  "video-components": "static-1.12808",
  "crm-export-dialog": "static-1.6166",
  "crm-index-associations-lib": "static-1.6307",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1512",
  "tanstack-virtual": "static-1.27",
  "nudge-custom-function-registry": "static-1.2053",
  "nudge-renderer-utils": "static-1.2372",
  "whisper-core-api": "static-1.6188",
  "InboxConnectUtils": "static-4.14415",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5218",
  "settings-content-modals": "static-1.45665",
  "crm_universal": "static-1.21771",
  "customer-data-email": "static-1.17796",
  "card-payment-highlight-lib": "static-1.36717",
  "card-subscription-highlight-lib": "static-1.39088",
  "commerce-contract-lib": "static-1.11463",
  "invoices-highlight-card-lib": "static-1.54254",
  "orders-highlight-card-lib": "static-1.21058",
  "products-highlight-card-lib": "static-1.17330",
  "quotes-highlight-card-lib": "static-1.71439",
  "crm-source-interpretation-lib": "static-1.5203",
  "utility-belt": "static-1.2412",
  "payments-enrollment-embed-lib": "static-1.22214",
  "customer-data-rte": "static-1.32625",
  "cv-backend-services": "static-1.1529",
  "growth-onboarding-empty-states": "static-1.5472",
  "payments-post-enroll-local-storage-lib": "static-1.4986",
  "qrcode-generator": "static-1.66",
  "quotes-client-types": "static-1.37529",
  "calling-orchestration-schema": "static-1.35234",
  "sales-views-client-types": "static-1.4135",
  "hub-http-contrib": "static-1.2915",
  "interframe": "static-3.4635",
  "tinymce-data": "static-1.40038",
  "ui-addon-sales-email": "static-1.5085",
  "layout-dnd-components": "static-1.12184",
  "layout-dnd-utils": "static-1.11159",
  "ui-brand-identity-lib": "static-1.14414",
  "NamespacedHubStyle": "static-2.8963",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4405",
  "video-embed": "static-1.35297",
  "social-insights-client-types": "static-1.21609",
  "deal-intel-utils": "static-1.1516",
  "checkout-sdk": "static-3.23334",
  "checkout-service-types": "static-1.3720",
  "company-details-components": "static-1.6058",
  "payment-method-components": "static-1.6766",
  "pricing-pages-ui-components": "static-1.13021",
  "quote-checkout-service-types": "static-1.3355",
  "upgrade-catalog-service-types": "static-1.3398",
  "access-control-lib": "static-1.10310",
  "EmailComponents": "static-1.54343",
  "EmailData": "static-1.53020",
  "redux-less": "static-2.9358",
  "sequences-lib": "static-1.7809",
  "ui-gdpr-components": "static-1.10220",
  "products-ui-components": "static-1.39565",
  "quotes-ui-lib": "static-1.80160",
  "accounting-integrations-ui-components": "static-1.6848",
  "invoices-ui-lib": "static-1.54270",
  "commerce-products-api": "static-1.2070",
  "invoices-iframe-lib": "static-1.56328",
  "quotes-modal-lib": "static-1.102117",
  "stripe-embedded-components": "static-1.7267",
  "draft-content-plugins": "static-1.27892",
  "ContentData": "static-1.67919",
  "layout-data-lib": "static-1.9484",
  "outpost": "static-1.4071",
  "hub-http-rxjs": "static-1.782",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3801",
  "billing-payments-client-types": "static-1.3861",
  "account-and-billing-fintech-outages": "static-3.18334",
  "pricing-pages-api": "static-1.12886",
  "ContentComponents": "static-2.70800",
  "marketing-contacts-lib": "static-1.9372",
  "marketing-email-service-types": "static-1.1821",
  "messaging-editing-lib": "static-1.45826",
  "messaging-usage-based-billing-components-lib": "static-1.688",
  "automation-ui-source-apps": "static-1.18435",
  "automation-ui-types": "static-1.19353",
  "messaging-types-lib": "static-1.45563",
  "onboarding-settings-client": "static-1.4377",
  "sequences-client-types-lib": "static-1.7666",
  "commerce-tax-lib": "static-1.390",
  "property-description-translator": "static-1.3726",
  "commerce-analytics-service-client": "static-1.3528",
  "totals-ui-components": "static-1.23182",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14919",
  "advanced-menus-lib": "static-1.11887",
  "ui-memberships-settings-lib": "static-1.33645",
  "demographics-service-types": "static-1.1521",
  "automation-ui-ubb": "static-1.5269",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7212",
  "data-token-views": "static-1.16150",
  "forms-utils-lib": "static-1.12312",
  "payments-embed-points-lib": "static-1.12751",
  "simple-menus-core": "static-1.14918",
  "simple-menus-lib": "static-1.16435",
  "ui-addon-draggable-compat": "static-2.4126",
  "videoconference-integration-components": "static-1.6631",
  "automation-applications-service-types": "static-1.3399",
  "automation-platform-service-types": "static-1.2544",
  "ContentEditorUI": "static-2.76732",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13527",
  "web-interactives-data": "static-1.13528",
  "messaging-shared-utils-lib": "static-1.137",
  "messaging-user-info-utils-lib": "static-1.307",
  "email-portal-health-service-types": "static-1.848",
  "commerce-totals-service-types": "static-1.3710",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21289",
  "automation-ui-usage-tracking": "static-1.20752",
  "data-studio-ubb": "static-1.2309",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26616",
  "collaboration-sidebar": "static-1.57331",
  "content-management-data-lib": "static-1.5209",
  "copilot-plugins": "static-1.10703",
  "cta-picker": "static-1.36025",
  "customer-agent-discovery-components-lib": "static-1.2640",
  "editor-components": "static-1.13037",
  "editor-iframe-lib": "static-1.8217",
  "error-messaging-js": "static-1.5062",
  "FireAlarmUi": "static-1.4403",
  "FormsCommonComponents": "static-1.85470",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.62",
  "redux-request-state": "static-1.10518",
  "SharedLegalStrings": "static-1.1624",
  "smart-content-core": "static-1.42049",
  "smart-content-lib": "static-1.42702",
  "social-composer-lib": "static-1.58428",
  "structured-content-lib": "static-1.24807",
  "theme-previewer-lib": "static-1.52877",
  "tinymce-copilot": "static-1.16021",
  "xray-recommendation-lib": "static-1.7696",
  "automation-ui-routing": "static-1.20710",
  "sql-reporting-client-types": "static-1.5535",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41834",
  "campaigns-utils-lib": "static-1.3028",
  "reporting-enablement": "static-1.22347",
  "chatspot-widget-iframe": "static-1.20634",
  "collaboration-sidebar-common": "static-1.2128",
  "forms-ai-lib": "static-1.4109",
  "codemirror-dlb": "static-1.58291",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6300",
  "report-customization-components": "static-1.12724",
  "data-quality-ui-library": "static-1.12506",
  "html-to-image": "static-1.51",
  "reporting-insights-lib": "static-1.1280"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11788",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.291",
  "data-fetching-client": "/data-fetching-client/static-1.9549",
  "foundations-components": "/foundations-components/static-1.7656",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.681",
  "foundations-theming": "/foundations-theming/static-1.4283",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.79",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7883",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9648",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11315",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6342",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11849",
  "quartz": "/quartz/static-1.6828",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16524",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2735",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8764",
  "settings-ui-lib": "/settings-ui-lib/static-1.12395",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6876",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11018",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9417",
  "unified-auth": "/unified-auth/static-1.308",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.589",
  "usage-tracker": "/usage-tracker/static-1.7209",
  "usage-tracker-core": "/usage-tracker-core/static-1.7059",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7954",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6091",
  "integrations-lib": "/integrations-lib/static-1.15645",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19164",
  "property-management-iframe": "/property-management-iframe/static-1.12656",
  "quartz-config": "/quartz-config/static-1.606",
  "quartz-core": "/quartz-core/static-1.6047",
  "quartz-routing": "/quartz-routing/static-1.258",
  "quick-fetch": "/quick-fetch/static-1.3807",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4516",
  "ts-schema": "/ts-schema/static-1.3974",
  "ui-universal-auth": "/ui-universal-auth/static-1.8794",
  "UIComponents": "/UIComponents/static-3.8262",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3298",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3105",
  "quartz-webpack": "/quartz-webpack/static-1.3052",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3925",
  "floating-ui": "/floating-ui/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4712",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1999",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-story-utils": "/hs-story-utils/static-1.9299",
  "react-aria": "/react-aria/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5242",
  "react-virtualized": "/react-virtualized/static-2.96",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1419",
  "ui-fonts": "/ui-fonts/static-1.577",
  "ui-images": "/ui-images/static-2.1123",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2766",
  "foundations-theming-base": "/foundations-theming-base/static-1.3268",
  "stylex": "/stylex/static-1.29",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2994",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4198",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8565",
  "ai-rendering-library": "/ai-rendering-library/static-1.9554",
  "chirp-fetch": "/chirp-fetch/static-1.1755",
  "connections-embed-lib": "/connections-embed-lib/static-1.736",
  "copilot-toolkit": "/copilot-toolkit/static-1.10730",
  "laboratory-lib": "/laboratory-lib/static-3.7033",
  "marketplace-embed": "/marketplace-embed/static-1.21663",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9060",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19120",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13335",
  "sanitize-text": "/sanitize-text/static-1.8017",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8568",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5623",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4895",
  "wootric-nps": "/wootric-nps/static-1.6856",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4523",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4026",
  "highcharts": "/highcharts/static-8.101",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2414",
  "reporting-data": "/reporting-data/static-1.66831",
  "cssUtils": "/cssUtils/static-1.764",
  "flux-actions": "/flux-actions/static-1.323",
  "HubStyle": "/HubStyle/static-2.11623",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10083",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10246",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7199",
  "icons": "/icons/static-2.637",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17697",
  "storybook-react": "/storybook-react/static-1.30",
  "trellis-story-utils": "/trellis-story-utils/static-1.4392",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5139",
  "quartz-i18n": "/quartz-i18n/static-1.503",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3603",
  "customer-data-objects": "/customer-data-objects/static-1.7526",
  "property-translator": "/property-translator/static-1.5280",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7796",
  "hs-promise-utils": "/hs-promise-utils/static-1.5468",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4751",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13060",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5464",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7659",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4346",
  "superstore": "/superstore/static-1.4641",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10018",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7665",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4547",
  "immutable-less": "/immutable-less/static-1.4526",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16571",
  "nav-meta": "/nav-meta/static-1.29155",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10114",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17771",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3740",
  "property-management-common": "/property-management-common/static-1.4944",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8919",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.503",
  "quartz-head": "/quartz-head/static-1.493",
  "quartz-test": "/quartz-test/static-1.503",
  "quartz-tracking": "/quartz-tracking/static-1.207",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3025",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20642",
  "ContentUtils": "/ContentUtils/static-1.67844",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2366",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39166",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12885",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13021",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13817",
  "ExportDialog": "/ExportDialog/static-6.10261",
  "highlight.js": "/highlight.js/static-1.76",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40850",
  "reporting-snowflake": "/reporting-snowflake/static-1.55449",
  "reporting-ui-components": "/reporting-ui-components/static-2.64102",
  "reporting-visualizations": "/reporting-visualizations/static-1.58907",
  "ui-addon-teams": "/ui-addon-teams/static-1.21347",
  "magpie-lib": "/magpie-lib/static-1.5466",
  "magpie-types": "/magpie-types/static-1.4926",
  "simple-logging-lib": "/simple-logging-lib/static-1.2922",
  "navigation-components": "/navigation-components/static-1.17518",
  "ai-studio-lib": "/ai-studio-lib/static-1.11196",
  "app-governance-lib": "/app-governance-lib/static-1.1102",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10374",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7863",
  "ui-product-approvals": "/ui-product-approvals/static-1.27699",
  "ui-tool-access": "/ui-tool-access/static-1.10017",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8213",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5626",
  "usage-tracker-public": "/usage-tracker-public/static-1.7020",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
  "persist-promise": "/persist-promise/static-1.3581",
  "reference-resolvers": "/reference-resolvers/static-1.8037",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3814",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.210",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2874",
  "final-form": "/final-form/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2379",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4942",
  "purchase-motions-components": "/purchase-motions-components/static-1.5608",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1424",
  "crm-component-utils": "/crm-component-utils/static-1.38665",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5745",
  "customer-data-properties": "/customer-data-properties/static-1.51019",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6747",
  "property-value-citations": "/property-value-citations/static-1.1633",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7958",
  "navigation-messaging": "/navigation-messaging/static-1.6845",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9646",
  "cms-field-types": "/cms-field-types/static-1.4681",
  "content-icons-ui": "/content-icons-ui/static-1.2187",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7121",
  "crm-message-bus": "/crm-message-bus/static-1.42584",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21601",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9696",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4593",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3902",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6652",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.850",
  "onboarding-tours": "/onboarding-tours/static-1.16368",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13265",
  "academy-common-lib": "/academy-common-lib/static-1.13277",
  "content-assistance-lib": "/content-assistance-lib/static-1.7549",
  "dashboard-lib": "/dashboard-lib/static-1.80926",
  "file-manager-components": "/file-manager-components/static-1.23142",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18082",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17815",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17807",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19598",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8565",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4640",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10815",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8905",
  "user-context": "/user-context/static-1.4972",
  "growth-payments-core": "/growth-payments-core/static-1.24930",
  "reporting-plugins": "/reporting-plugins/static-1.10070",
  "reporting-reports": "/reporting-reports/static-1.66509",
  "idb-keyval": "/idb-keyval/static-1.41",
  "reactive-lib": "/reactive-lib/static-1.597",
  "codemirror": "/codemirror/static-5.92",
  "feedback-loader": "/feedback-loader/static-1.29018",
  "react-codemirror": "/react-codemirror/static-1.10498",
  "framework-listing-lib": "/framework-listing-lib/static-2.28242",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30307",
  "apps-service-types": "/apps-service-types/static-1.3749",
  "oauth-service-types": "/oauth-service-types/static-1.4119",
  "onboarding-scopes": "/onboarding-scopes/static-1.6335",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4582",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7561",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14680",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3511",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8786",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4371",
  "nav-client-types": "/nav-client-types/static-1.2229",
  "purchase-motions-api": "/purchase-motions-api/static-1.5611",
  "signup-constants": "/signup-constants/static-1.18559",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7907",
  "trials-service-types": "/trials-service-types/static-1.3772",
  "card-properties-lib": "/card-properties-lib/static-1.43729",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36665",
  "crm-actions": "/crm-actions/static-1.6183",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43141",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8975",
  "customer-data-tracking": "/customer-data-tracking/static-1.6756",
  "hs-entities": "/hs-entities/static-1.561",
  "pulse": "/pulse/static-1.400",
  "calling-global-api": "/calling-global-api/static-1.63952",
  "calling-internal-common": "/calling-internal-common/static-1.31172",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65334",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57628",
  "commerce-products-lib": "/commerce-products-lib/static-1.9046",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3692",
  "crm-links": "/crm-links/static-1.6143",
  "external-options-client-types": "/external-options-client-types/static-1.4053",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4117",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.504",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3584",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48249",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3858",
  "smart-property-lib": "/smart-property-lib/static-1.6232",
  "tiered-pricing": "/tiered-pricing/static-1.945",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10865",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4036",
  "react-dnd-compat": "/react-dnd-compat/static-1.4492",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5232",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2944",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1488",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.434",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7399",
  "academy-service-client": "/academy-service-client/static-1.3552",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28136",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8257",
  "video-components-external": "/video-components-external/static-1.10805",
  "video-data-lib": "/video-data-lib/static-1.34463",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8430",
  "payment-link-components": "/payment-link-components/static-1.23128",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9759",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24048",
  "viral-links-lib": "/viral-links-lib/static-1.6912",
  "data-token-picker": "/data-token-picker/static-1.16169",
  "FileManagerLib": "/FileManagerLib/static-1.38782",
  "react-flip-move": "/react-flip-move/static-1.67",
  "timezone-utils": "/timezone-utils/static-2.5116",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17200",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8499",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7194",
  "customer-data-views-management": "/customer-data-views-management/static-1.25136",
  "framework-data-table": "/framework-data-table/static-2.11595",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6719",
  "nudge-client-utils": "/nudge-client-utils/static-1.2296",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.797",
  "app-users-service-client": "/app-users-service-client/static-1.5417",
  "app-users-service-types": "/app-users-service-types/static-1.4825",
  "mini-checkout-client": "/mini-checkout-client/static-1.26491",
  "onboarding-utils": "/onboarding-utils/static-1.5224",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28121",
  "edison-service-client-types": "/edison-service-client-types/static-1.264",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3053",
  "crm_data": "/crm_data/static-4.91488",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45613",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15350",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18688",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18149",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9987",
  "crm-fe-perf": "/crm-fe-perf/static-1.22776",
  "directed-graph": "/directed-graph/static-1.811",
  "event-emitter": "/event-emitter/static-1.819",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "calling-error-reporting": "/calling-error-reporting/static-1.31178",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10911",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6413",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.457",
  "commerce-permissions": "/commerce-permissions/static-1.637",
  "products-iframe-lib": "/products-iframe-lib/static-1.7532",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10030",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5422",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9731",
  "policy-lib": "/policy-lib/static-1.6651",
  "react-tinymce": "/react-tinymce/static-1.54827",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9794",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53953",
  "tinymce-plugins": "/tinymce-plugins/static-1.57067",
  "tinymce-themes": "/tinymce-themes/static-1.55923",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1516",
  "user-context-client": "/user-context-client/static-1.4485",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6453",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11744",
  "content-media-compositions": "/content-media-compositions/static-2.15751",
  "media-bridge-lib": "/media-bridge-lib/static-1.18691",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5837",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4958",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3540",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21436",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3715",
  "audio-components": "/audio-components/static-1.5713",
  "FileManagerCore": "/FileManagerCore/static-1.38641",
  "FileManagerImages": "/FileManagerImages/static-1.36293",
  "video-components": "/video-components/static-1.12808",
  "crm-export-dialog": "/crm-export-dialog/static-1.6166",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6307",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1512",
  "tanstack-virtual": "/tanstack-virtual/static-1.27",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2053",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2372",
  "whisper-core-api": "/whisper-core-api/static-1.6188",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14415",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5218",
  "settings-content-modals": "/settings-content-modals/static-1.45665",
  "crm_universal": "/crm_universal/static-1.21771",
  "customer-data-email": "/customer-data-email/static-1.17796",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36717",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39088",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11463",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54254",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21058",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17330",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71439",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5203",
  "utility-belt": "/utility-belt/static-1.2412",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22214",
  "customer-data-rte": "/customer-data-rte/static-1.32625",
  "cv-backend-services": "/cv-backend-services/static-1.1529",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5472",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4986",
  "qrcode-generator": "/qrcode-generator/static-1.66",
  "quotes-client-types": "/quotes-client-types/static-1.37529",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35234",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "hub-http-contrib": "/hub-http-contrib/static-1.2915",
  "interframe": "/interframe/static-3.4635",
  "tinymce-data": "/tinymce-data/static-1.40038",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5085",
  "layout-dnd-components": "/layout-dnd-components/static-1.12184",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11159",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14414",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8963",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4405",
  "video-embed": "/video-embed/static-1.35297",
  "social-insights-client-types": "/social-insights-client-types/static-1.21609",
  "deal-intel-utils": "/deal-intel-utils/static-1.1516",
  "checkout-sdk": "/checkout-sdk/static-3.23334",
  "checkout-service-types": "/checkout-service-types/static-1.3720",
  "company-details-components": "/company-details-components/static-1.6058",
  "payment-method-components": "/payment-method-components/static-1.6766",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13021",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3355",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3398",
  "access-control-lib": "/access-control-lib/static-1.10310",
  "EmailComponents": "/EmailComponents/static-1.54343",
  "EmailData": "/EmailData/static-1.53020",
  "redux-less": "/redux-less/static-2.9358",
  "sequences-lib": "/sequences-lib/static-1.7809",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10220",
  "products-ui-components": "/products-ui-components/static-1.39565",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80160",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6848",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54270",
  "commerce-products-api": "/commerce-products-api/static-1.2070",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56328",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102117",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7267",
  "draft-content-plugins": "/draft-content-plugins/static-1.27892",
  "ContentData": "/ContentData/static-1.67919",
  "layout-data-lib": "/layout-data-lib/static-1.9484",
  "outpost": "/outpost/static-1.4071",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.782",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3801",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3861",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18334",
  "pricing-pages-api": "/pricing-pages-api/static-1.12886",
  "ContentComponents": "/ContentComponents/static-2.70800",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9372",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1821",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45826",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.688",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18435",
  "automation-ui-types": "/automation-ui-types/static-1.19353",
  "messaging-types-lib": "/messaging-types-lib/static-1.45563",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4377",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7666",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.390",
  "property-description-translator": "/property-description-translator/static-1.3726",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3528",
  "totals-ui-components": "/totals-ui-components/static-1.23182",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14919",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11887",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33645",
  "demographics-service-types": "/demographics-service-types/static-1.1521",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5269",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7212",
  "data-token-views": "/data-token-views/static-1.16150",
  "forms-utils-lib": "/forms-utils-lib/static-1.12312",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12751",
  "simple-menus-core": "/simple-menus-core/static-1.14918",
  "simple-menus-lib": "/simple-menus-lib/static-1.16435",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4126",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6631",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3399",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2544",
  "ContentEditorUI": "/ContentEditorUI/static-2.76732",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13527",
  "web-interactives-data": "/web-interactives-data/static-1.13528",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.137",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.307",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.848",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3710",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21289",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20752",
  "data-studio-ubb": "/data-studio-ubb/static-1.2309",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26616",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57331",
  "content-management-data-lib": "/content-management-data-lib/static-1.5209",
  "copilot-plugins": "/copilot-plugins/static-1.10703",
  "cta-picker": "/cta-picker/static-1.36025",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2640",
  "editor-components": "/editor-components/static-1.13037",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8217",
  "error-messaging-js": "/error-messaging-js/static-1.5062",
  "FireAlarmUi": "/FireAlarmUi/static-1.4403",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85470",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.62",
  "redux-request-state": "/redux-request-state/static-1.10518",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1624",
  "smart-content-core": "/smart-content-core/static-1.42049",
  "smart-content-lib": "/smart-content-lib/static-1.42702",
  "social-composer-lib": "/social-composer-lib/static-1.58428",
  "structured-content-lib": "/structured-content-lib/static-1.24807",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52877",
  "tinymce-copilot": "/tinymce-copilot/static-1.16021",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7696",
  "automation-ui-routing": "/automation-ui-routing/static-1.20710",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5535",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41834",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3028",
  "reporting-enablement": "/reporting-enablement/static-1.22347",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20634",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2128",
  "forms-ai-lib": "/forms-ai-lib/static-1.4109",
  "codemirror-dlb": "/codemirror-dlb/static-1.58291",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6300",
  "report-customization-components": "/report-customization-components/static-1.12724",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12506",
  "html-to-image": "/html-to-image/static-1.51",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1280"
}
};
